export default __webpack_public_path__ + "static/media/selectScreenH2.dbecba3f.png";